import { useEffect } from "react";
import { useSelector } from "react-redux";
import { CustomCard, Title } from "../../Utils/UI/Text";
import CostCentersBoard from "./CostCentersBoard";
import { getCostCenters } from "../Application/CostCenters.business";
import {
  getCostCentersSelector,
  getCostCentersCountSelector,
} from "../Infrastructure/CostCenters.reducer";
import "./CostCenters.css";
import ExportButtonElement from "../../Layout/DesignSystem/ExportButton/Button";
import NewCostCenters from "./NewCostCenters";

const CostCenters = () => {
  const costCenters = useSelector(getCostCentersSelector);
  const totalCountCostCenters = useSelector(getCostCentersCountSelector);

  useEffect(() => {
    getCostCenters();
  }, []);
  return (
    <>
      <Title
        children="Centros de Costos"
        childrenTwo={<NewCostCenters />}
        childrenThree={
          <ExportButtonElement type={"costCenter"} text={"Exportar"} />
        }
      />
      <CustomCard>
        <CostCentersBoard
          costCenters={costCenters}
          getCostCenters={getCostCenters}
          totalCountCostCenters={totalCountCostCenters}
        />
      </CustomCard>
    </>
  );
};

export default CostCenters;
